
















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VCheckbox from "@/components/VCheckbox.vue";

@Component({
  components: {
    VCheckbox,
  },
})
export default class GroupCard extends Vue {
  @Prop() private readonly title!: string;
  @Prop() private readonly subTitle?: string;
  @Prop() private readonly value!: boolean;

  private selected = this.value;

  @Watch("value")
  onValueChanged() {
    this.selected = this.value;
  }

  @Watch("selected")
  onSelectedChanged() {
    this.$emit("change", this.selected);
  }
}
